module.exports = __webpack_public_path__ + "img/b19466265c5b1aec3818de711d15b85d.png";